import React, { useEffect, useState, useCallback } from 'react';
import Select from 'react-select';
import MessageGrid from '../purchaseRequisition/messageGrid';
import ItemGridGRN from '../Goods&Receipt/grnList/itemGrid';
import { toast } from 'react-toastify';
import AuthorizationGrn from '../Goods&Receipt/authorization';
import { useNavigate } from 'react-router-dom';
import ApiService from '../../services/apiService';
import DirectPurchaseGrid from './directPurchaseGrid';
import { useSelector } from 'react-redux';
import { getCompany, getName, getUserId, getUserName } from '../../../Redux/selecters';
import { RiRefreshLine } from 'react-icons/ri';
import { FaAngleLeft } from 'react-icons/fa6';
import { FaSave } from 'react-icons/fa';
import { ClipLoader } from 'react-spinners';
import Modal from 'react-bootstrap/Modal';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import Attachment from '../Attachment/attachment';

const createEmptyRow = () => ({
  id: Date.now() + Math.random(),
  file: null,
  fileName: '',
  remarks: '',
});

const CreateDirectPurchase = () => {
  const [activeTab, setActiveTab] = useState(0);
  const REPORT_URL = process.env.REACT_APP_REPORTS_URL;
  const [gridVisibility, setGridVisibility] = useState([true, false, false]);
  const apiService = new ApiService();
  const { currencyPrecision } = useCurrency();
  const [messageData, setMessageData] = useState([]);
  const [authorizationData, setAuthorizationData] = useState([]);
  const [ItemData, setItemData] = useState([]);
  const [POData, setPOData] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [usersDetails, setUser] = useState([]);
  const [Department, setDepartment] = useState([]);
  const [WareHouse, setWareHouse] = useState([]);
  const [isVatExcluded, setIsVatExcluded] = useState(false);
  const [supplierCheck, setSupplierCheck] = useState('Supplier');
  const [Userdata, setUserdata] = useState();
  const [currency, setCurrency] = useState([]);
  const [SelectedCurrency, setSelectedCurency] = useState([]);
  const currentDatetimeUTC = new Date().toISOString().slice(0, 16);
  const userId = useSelector(getUserId);
  const userName = useSelector(getUserName);
  const Company = useSelector(getCompany);
  const [SupplierTab, setSupplierTab] = useState(false);
  const [POTab, setPOTab] = useState(true);
  const [CostTab, setCostTab] = useState(false);
  const [OtherTab, setOtherTab] = useState(true);
  const [cost1, setCost1] = useState([]);
  const [cost2, setCost2] = useState([]);
  const [cost3, setCost3] = useState([]);
  const [cost4, setCost4] = useState([]);
  const [loader, setLoader] = useState(false);
  const [docModal, setDocModal] = useState(false);
  const onOpenModal = () => setDocModal(true);
  const onCloseModal = () => setDocModal(false);
  const [currencyList, setCurrencyList] = useState([]);
  const [itemtype, setItemtype] = useState({ label: "Inventory", value: "Inventory" });

  // Attachment
  const [attachmentModal, setAttachmentModal] = useState(false);
  const [previewModal, setPreviewModal] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [attachments, setAttachments] = useState([createEmptyRow()]);
  const handleOpen = () => setAttachmentModal(true);
  const closeModal = () => setAttachmentModal(false);
  const isReadOnly = false;

  const getCurrentLocalDatetime = () => {
    const localDate = new Date();
    const offset = localDate.getTimezoneOffset() * 60000;
    const localISOTime = new Date(localDate - offset).toISOString().slice(0, 16);
    return localISOTime;
  };
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
    getApprovalUser();
    getCurrency();
  }, []);
  const handleVatChange = () => {
    setIsVatExcluded(!isVatExcluded);
  };
  const handleSuppChange = (val) => {
    setSupplierCheck(val);
  };
  let param = `?isActive=true`;
  const fetchData = async () => {
    const Supplier = await apiService.get('GET_SUPPLIER');
    setSupplier(Supplier?.data?.result);
    const department = await apiService.get('GET_DEPARTMENT_MASTER');
    setDepartment(department?.data?.result);
    let param = `?Exp3=1`;
    let WareHouse = await apiService.getApiParamater('GET_WAREHOUSE_MASTER', param);
    setWareHouse(WareHouse?.data?.result);
    let cost1 = await apiService.get('GET_COST_ONE');
    setCost1(cost1?.data?.result);
    let cost2 = await apiService.get('GET_COST_TWO');
    setCost2(cost2?.data?.result);
    let cost3 = await apiService.get('GET_COST_THREE');
    setCost3(cost3?.data?.result);
    let cost4 = await apiService.get('GET_COST_FOUR');
    setCost4(cost4?.data?.result);
  };

  const handlecurChange = (selectedOption) => {
    setSelectedCurency(selectedOption)
    setFormData({ ...formData, exchangeRate: selectedOption?.value?.conversionRate });
  };
  const getCurrency = async () => {
    const currencylist = JSON.parse(localStorage.getItem('currencylist')) || [];
    const newDefaultCurrency = currencylist?.find((comp) => comp.isDefault === true);
    setSelectedCurency({ label: newDefaultCurrency.code, value: newDefaultCurrency });
    setFormData({ ...formData, exchangeRate: newDefaultCurrency.conversionRate });
    setCurrencyList(currencylist)
  };
  const getApprovalUser = async () => {
    try {
      const params = new URLSearchParams();
      let docParam = `?TypeOfDoc=GRN&DocId=GRN`;
      const docRes = await apiService.getApiParamater('GET_DOC_ID', docParam);
      setFormData({ ...formData, GRNNO: docRes?.data.result[0].docId });
      setPOData(docRes?.data.result[0]);

      params.append('DocNo', '');
      params.append('DocumentType', 'GRN');
      const response = await apiService.getApiParamater('GET_DOC_STATUS_EDIT', `?${params.toString()}`);
      setUser(response.data.result);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
    setGridVisibility(newGridVisibility);
  };
  const handleMessage = (data) => {
    setMessageData(data);
    console.log(data, 'reqData');
  };
  const handleRequisitionData = (data) => {
    setItemData(data);
    console.log(data, 'reqData');
  };
  const handleAuthorization = (data) => {
    setAuthorizationData(data);
    console.log(data, 'reqData');
  };
  const [formData, setFormData] = useState({
    GRNNO: '',
    deliveryNote: '',
    remarks: '',
    InvoiceNo: '',
    InvoiceDate: getCurrentLocalDatetime(),
    deliveryDate: getCurrentLocalDatetime(),
    PropertyGroup: '',
    TaxInvoice: '',
    Property: '',
    Department: '',
    Outlet: '',
    Currency: '',
    exchangeRate: SelectedCurrency?.value?.conversionRate,
    deliveryPoint: '',
    PurchaseOrderDate: getCurrentLocalDatetime(),
    contactPerson: '',
    contatNo: '',
    itemCode: '',
    itemDescription: '',
    subcatname: '',
    location: '',
    vendorName: [],
    vendorId: [],
    addCharges: '',
  });
  const staticOptions = [];
  const itemType = [
    { value: 'Inventory', label: 'Inventory' },
    { value: 'FixedAsset', label: 'Fixed Asset' },
    { value: 'Services', label: 'Services' },
  ];
  const handleLocationChange = (selectedOption) => {
    setFormData({ ...formData, location: selectedOption });
  };
  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const GenerateNumber = async () => {
    let docParam = `?TypeOfDoc=GRN&DocId=GRN`;
    const DocId = await apiService.getApiParamater('GET_DOC_ID', docParam);
    setFormData({ ...formData, GRNNO: DocId?.data.result[0].docId });
    setPOData(DocId?.data.result[0]);
    onCloseModal();
  };
  const CreateGRN = async () => {
    setLoader(true);
    if (!formData.location.label) {
      toast.warning('Enter location');
      setLoader(false);
      return;
    }
    if (!formData.vendorName?.label) {
      toast.warning('Select Supplier');
      setLoader(false);
      return;
    }
    if (ItemData.length === 0) {
      toast.warning('Please add items');
      setLoader(false);
      return;
    }
    for (const item of ItemData) {
      if (!item.itemDescription) {
        toast.warning(`Please Select Item`);
        setLoader(false);
        return;
      } else if (!item.qty) {
        toast.warning(`Please enter ${item.itemDescription} quantity`);
        setLoader(false);
        return;
      } else if (!item.qty || parseFloat(item.qty) <= 0) {
        toast.warning(`${item.itemDescription} quantity must be greater than 0`);
        setLoader(false);
        return;
      } else if (!item.baseAmount || parseFloat(item.baseAmount) <= 0) {
        toast.warning(`${item.itemDescription} unit price must be greater than 0`);
        setLoader(false);
        return;
      }
    }
    const missingGL = ItemData.find((item) => !item.inventoryAccountCode);
    if (missingGL) {
      toast.warning(`Please Add GL Accounts for ${missingGL?.itemDescription}`);
      setLoader(false);
      return;
    }
    const missingGRNAcc = ItemData.find((item) => !item.GRNAccountCode);
    if (missingGRNAcc) {
      toast.warning(`Please Add GL Accounts for ${missingGRNAcc?.itemDescription}`);
      setLoader(false);
      return;
    }
    try {
      const totalAmount = ItemData.reduce((sum, row) => sum + (row.amount || 0), 0);
      const vatAmount = ItemData.reduce((sum, row) => sum + parseFloat(row.vatAmount || 0), 0);
      const grossAmount = parseFloat(totalAmount || 0) - parseFloat(vatAmount || 0);
      const currentDatetimeUTC = new Date().toISOString();
      const GRNDetailsData = ItemData.map((item, index) => {
        const grossAmount = parseFloat(item.amount || 0) - parseFloat(item.vatAmount || 0);
        if (item?.batchNo) {
          if (!item?.expDate) {
            toast.warning(`Please Select Exp Date of ${item.itemDescription}`);
            setLoader(false);
            return;
          }
        }
        if (item?.expDate) {
          if (!item?.batchNo) {
            toast.warning(`Please Enter Batch No of ${item.itemDescription}`);
            setLoader(false);
            return;
          }
        }
        return {
          requisitionNo: item?.requisitionNo,
          srno: index + 1,
          itemCode: item?.ItemNo,
          itemDescription: item.itemDescription,
          uom: item.uom,
          qty: parseFloat(item.qty || 0),
          baseUOM: item?.uom,
          baseQty: parseFloat(item.baseQty),
          specification: item.specification,
          convValue: parseFloat(item?.baseQty),
          unitPrice: Number(item.baseAmount).toFixed(currencyPrecision || 3),
          amount: Number(item.amount).toFixed(currencyPrecision || 3),
          baseAmount: Number(item.amount).toFixed(currencyPrecision || 3),
          convToInvUOM: parseFloat(item.baseQty),
          importedQty: 0,
          prodDate: currentDatetimeUTC,
          expDate: item?.expDate,
          batchNo: item.batchNo,
          isActive: true,
          returnQty: 0,
          invoicedQty: 0,
          extraQty: 0,
          grossAmount: Number(grossAmount).toFixed(currencyPrecision || 3),
          grossBaseAmount: Number(grossAmount).toFixed(currencyPrecision || 3),
          addCharges: Number(formData.addCharges).toFixed(currencyPrecision || 3),
          vatAmount: parseFloat(item.vatAmount),
          vatUnitPrice: Number(item.vatAmount / item.qty).toFixed(currencyPrecision || 3),
          vatBaseAmount: Number(item.vatAmount).toFixed(currencyPrecision || 3),
          vatInclusive: isVatExcluded === true ? false : true,
          vatCode: 1,
          vatDesc: item.vatDes,
          vatPerc: item.vat,
          inventoryAccountCode: item?.inventoryAccountCode,
          inventoryAccountName: item?.inventoryAccountName,
        };
      });
      const userData = {
        grnNo: formData.GRNNO,
        pOrderNo: formData.GRNNO,
        delivery_Date: formData.deliveryDate,
        status: 0,
        invoiceDate: formData.InvoiceDate,
        remarks: formData?.remarks,
        modifiedOn: currentDatetimeUTC,
        modifiedBy: userName,
        vendorId: formData.vendorId?.label.toString(),
        vendorName: formData.vendorName?.label,
        terms: formData.vendorName.value.paymentTerm,
        department: formData?.Department,
        costCenter1: formData.costCenter1?.label,
        costCenter2: formData.costCenter2?.label,
        costCenter3: formData.costCenter3?.label,
        costCenter4: formData.costCenter4?.label,
        isActive: true,
        currencyCode: SelectedCurrency.label,
        exchangeRate: SelectedCurrency?.value.conversionRate,
        grnDetailsDtos: GRNDetailsData,
        warehouse: formData?.location.label,
        transport_Mode: 'Direct',
        transporter: supplierCheck,
        invoiceNo: formData.InvoiceNo,
        invoiceRef: formData.deliveryNote,
        batchNo: formData.TaxInvoice,
        vatInclusive: isVatExcluded === true ? false : true,
        vatAmount: parseFloat(vatAmount),
        baseAmount: Number(totalAmount).toFixed(currencyPrecision || 3),
        amount: Number(totalAmount).toFixed(currencyPrecision || 3),
        grossAmount: Number(grossAmount).toFixed(currencyPrecision || 3),
        grossBaseAmount: Number(grossAmount).toFixed(currencyPrecision || 3),
      };

      const response = await apiService.post('CREATE_GRN', userData);

      if (response?.data?.statusCode === 201) {
        const userData2 = {
          docType: 'GRN',
          docId: formData.GRNNO,
          department: 'IT',
          company: Company?.selectedCompany?.companyNo,
          userCode: userId,
          userName: userName,
        };
        const docBody = {
          docId: 'GRN',
          typeOfDoc: 'GRN',
        };
        const docRes = await apiService.put('UPDATE_DOC_ID', docBody);
        if (attachments) {
          let name = 'DirectPurchase';
          let docNo = formData.GRNNO;
          handleUpload(name, docNo);
        }
        const response2 = await apiService.post('CREATE_DOC_AUTHORIZATION', userData2);
        const paramsGet = new URLSearchParams();
        paramsGet.append('docType', 'GRN');
        paramsGet.append('docId', formData.GRNNO);
        paramsGet.append('srno', 1);
        const response3 = await apiService.getApiParamater('GET_DOC_APPROVAL_USER', `?${paramsGet.toString()}`);
        // if (response3?.data?.result.length > 0) {
        //   const toEmails = response3?.data?.result?.map((user) => user.userEmail);
        //   const emailbody = {
        //     toEmails: toEmails,
        //     subject: 'Direct Purchase',
        //     body: '',
        //     docNo: formData.GRNNO,
        //     srNo: 1,
        //     docType: 'GRN',
        //   };
        //   const emailres = await apiService.post('DOC_APPROVAL_EMAIL_POST', emailbody);
        // }
        const token = localStorage.getItem('Token');
        const DB = localStorage.getItem('DataBase');
        if (!token) {
          alert('Auth token is missing! Unable to proceed.');
          return;
        }
        const popupWidth = 1000;
        const popupHeight = 600;
        const popupLeft = (window.screen.width - popupWidth) / 2;
        const popupTop = (window.screen.height - popupHeight) / 2;
        const popup = window.open(
          '',
          'ReportPopup',
          `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`,
        );

        if (popup) {
          const form = document.createElement('form');
          form.method = 'POST';
          form.action = REPORT_URL;
          form.target = 'ReportPopup';

          const inputs = [
            { name: 'authToken', value: token },
            { name: '_db', value: DB },
            { name: 'reportName', value: 'DirectPurchase' },
            { name: 'voucherNo', value: formData.GRNNO },
          ];

          inputs.forEach(({ name, value }) => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = name;
            input.value = value;
            form.appendChild(input);
          });

          document.body.appendChild(form);
          form.submit();
          document.body.removeChild(form);
        }
        toast.success(`${formData.GRNNO} Created successfully`);
        setLoader(false);
        navigate('/Inventory/DirectPurchase/List');
      } else if (response?.data?.statusCode === 208) {
        setLoader(false);
        onOpenModal();
      }
    } catch (error) {
      setLoader(false);
      console.error('Error Creating PR:', error);
    }
  };
  const handleSupplierChange = (selectedOption) => {
    setFormData({
      ...formData,
      vendorName: { label: selectedOption.value.supplierName, value: selectedOption },
      vendorId: { label: selectedOption.value.supplier_ID, value: selectedOption },
    });
  };
  const handleBackClick = () => {
    window.history.back();
  };
  const handleCost1 = async (selectedOption) => {
    let param = `?DropdownFor=GetUnitsByPropId&CascadValue=${selectedOption?.value?.exp1}`
    const response = await apiService.getApiParamater('GET_PR_CASCAD', param);
    let data = response?.data?.items || []
    setCost2([{ value: null, text: 'None' }, ...data]);
    setFormData({ ...formData, costCenter1: selectedOption });
  };
  const handleCost2 = (selectedOption) => {
    setFormData({ ...formData, costCenter2: selectedOption });
  };
  const handleCost3 = (selectedOption) => {
    setFormData({ ...formData, costCenter3: selectedOption });
  };
  const handleCost4 = (selectedOption) => {
    setFormData({ ...formData, costCenter4: selectedOption });
  };
  const handleTypeChange = (selectedOption) => {
    setItemtype(selectedOption)
  };

  // Attachment Functions
  const handleFileSelect = useCallback((file, id) => {
    setAttachments((prev) => {
      const updated = prev.map((row) => (row.id === id ? { ...row, file, fileName: file.name } : row));
      return [...updated, createEmptyRow()];
    });
  }, []);
  const handleRemarkChange = (id, value) => {
    setAttachments((prev) => prev.map((row) => (row.id === id ? { ...row, remarks: value } : row)));
  };
  const handleDelete = (id) => {
    setAttachments((prev) => prev.filter((row) => row.id !== id));
  };
  const handleView = (file) => {
    if (!file) return;

    if (isReadOnly) {
      setPreviewImage(file);
    } else {
      setPreviewImage(URL.createObjectURL(file));
    }
    setPreviewModal(true);
  };
  const handleUpload = async (name, docNo) => {
    const formData = new FormData();

    attachments.forEach(({ file }) => {
      if (file instanceof File) {
        formData.append('Images', file, file.name);
      }
    });

    const response = await apiService.postMultiPart('UPLOAD_FILE', formData);

    if (response?.data?.statusCode === 201 && response?.data?.isSuccessful) {
      const uploadedFileNames = response.data.result.split(',');

      const payload = {
        docFilesDtos: attachments
          .filter((a) => a.file)
          .map((a, index) => ({
            srno: index + 1,
            docNo: docNo,
            docType: name,
            fileName: uploadedFileNames[index]?.trim(),
            remarks: a.remarks || '',
          })),
      };

      await apiService.post('CREATE_ATTACHMENT', payload);
      return;
    }
  };
  return (
    <div className="px-4">
      <div className="d-flex justify-content-between pt-3">
        <h5 className="col mainInvHead">Direct Purchase</h5>
        <div className="d-flex gap-3">
          {loader === true ? (
            <button className="mainbtn " type="submit">
              <ClipLoader color="#ffffff" size={25} />
            </button>
          ) : (
            <button className="mainbtn " type="submit" onClick={CreateGRN}>
              <FaSave className="center mt-1 mx-2" />
              <div>Save</div>
            </button>
          )}
          <button className="mainbtnRed">
            <RiRefreshLine className="center mt-1 mx-2" />
            <div>Reset</div>
          </button>
          <button onClick={handleBackClick} className="mainbtnSecondary">
            <FaAngleLeft className="center mt-1 mx-2" />
            <div>Back</div>
          </button>
        </div>
      </div>
      <div className="cost-center-section">
        <div className="d-flex mt-3 cursor-pointer slide-header" onClick={() => setPOTab(!POTab)}>
          <div className="h6 pt-1">Purchase Details</div>
        </div>
        <div className={`slide-content ${POTab ? 'open' : 'closed'}`}>
          <div className={`border-box2 p-3 ${POTab ? 'slide-in' : 'slide-out'}`}>
            <div className="form-group row pb-3">
              <div className="d-flex justify-content-between col">
                <label htmlFor="GRNNO" className="form-label  pt-2 start">
                  DP GRN No
                </label>
                <input className="form-Input w-100" value={formData.GRNNO} onChange={handleInputChange} disabled />
              </div>
              <div className="d-flex justify-content-between col">
                <label htmlFor="catcode" className="form-label  pt-2 start">
                  GRN Date
                </label>
                <input className="form-Input w-100" type="datetime-local" name="deliveryDate" value={formData.deliveryDate} onChange={handleInputChange} />
              </div>
              <div className="col center">
                <button className="mainbtn ">Advance Search</button>
              </div>
            </div>
            <div className="form-group row pb-3">
              <div className="d-flex justify-content-between col">
                <label htmlFor="InvoiceNo" className="form-label  pt-2 start">
                  Invoice No
                </label>
                <input
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  className="form-Input w-100"
                  id="InvoiceNo"
                  value={formData.InvoiceNo}
                  onChange={handleInputChange}
                  name="InvoiceNo"
                />
              </div>
              <div className="d-flex justify-content-between col">
                <label htmlFor="InvoiceDate" className="form-label  pt-2 start">
                  Invoice Date
                </label>
                <input
                  type="datetime-local"
                  className="form-Input w-100"
                  id="InvoiceDate"
                  value={formData.InvoiceDate}
                  onChange={handleInputChange}
                  name="InvoiceDate"
                />
              </div>
              <div className="d-flex justify-content-between col">
                <label htmlFor="itemCode" className="form-label  pt-2 start">
                  Item No
                </label>
                <input type="text" className="form-Input w-100" name="itemCode" value={formData.itemCode} onChange={handleInputChange} />
              </div>
            </div>
            <div className="form-group row pb-3">
              <div className="d-flex justify-content-between col">
                <label htmlFor="TaxInvoice" className="form-label  pt-2 start">
                  Tax Invoice No ( KRA )
                </label>
                <input
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  className="form-Input w-100"
                  id="TaxInvoice"
                  value={formData.TaxInvoice}
                  onChange={handleInputChange}
                  name="TaxInvoice"
                />
              </div>
              <div className="d-flex justify-content-between col">
                <label htmlFor="deliveryNote" className="form-label  pt-2 start">
                  Delivery Note No
                </label>
                <input
                  type="text"
                  className="form-Input w-100"
                  id="deliveryNote"
                  value={formData.deliveryNote}
                  onChange={handleInputChange}
                  name="deliveryNote"
                />
              </div>
              <div className="d-flex justify-content-between col">
                <label htmlFor="catcode" className="form-label  pt-2 start">
                  Item Description
                </label>
                <input className="form-Input w-100" type="text" name="itemDescription" value={formData.itemDescription} onChange={handleInputChange} />
              </div>
            </div>
            <div className="form-group row pb-3">
              <div className="d-flex justify-content-between col">
                <label htmlFor="PropertyGroup" className="form-label  pt-2 start">
                  Item Type
                </label>
                <Select
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  className="w-100 p-0"
                  options={itemType}
                  value={itemtype}
                  onChange={(selectedOption) => handleTypeChange(selectedOption)}
                />
              </div>
              <div className="d-flex justify-content-between col">
                <label htmlFor="Location" className="form-label  pt-2 start">
                  Location
                </label>
                <Select
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  className="w-100 p-0"
                  value={formData.location}
                  onChange={handleLocationChange}
                  options={WareHouse?.map((sup) => ({ value: sup, label: sup?.description }))}
                />
              </div>
              <div className="col">
                <div className="d-flex p-1 brderbox gap-2 justify-content-around " style={{ background: '#d9d9d95e' }}>
                  <div className="form-check gap-3 center">
                    <input
                      style={{ width: '20px', height: '20px' }}
                      onClick={() => handleSuppChange('Supplier')}
                      checked={supplierCheck === 'Supplier' ? true : false}
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id={supplierCheck}
                    />
                    <label className="form-check-label" for="Supplier">
                      Supplier
                    </label>
                  </div>
                  <div className="form-check gap-3 center">
                    <input
                      className="form-check-input"
                      style={{ width: '20px', height: '20px' }}
                      type="radio"
                      name="flexRadioDefault"
                      id={supplierCheck}
                      checked={supplierCheck === 'Cash' ? true : false}
                      onClick={() => handleSuppChange('Cash')}
                    />
                    <label className="form-check-label" for="Cash">
                      Cash Purchase
                    </label>
                  </div>
                  <div className="form-check gap-3 center">
                    <input
                      className="form-check-input"
                      style={{ width: '20px', height: '20px' }}
                      type="radio"
                      name="flexRadioDefault"
                      id={supplierCheck}
                      checked={supplierCheck === 'Sample' ? true : false}
                      onClick={() => handleSuppChange('Sample')}
                    />
                    <label className="form-check-label" for="Sample">
                      sample
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="form-group row">
              <div className="d-flex justify-content-between col-4">
                <label htmlFor="addCharges" className="form-label  pt-2 start">
                  Add Charges
                </label>
                <input type="text" className="form-Input w-100" id="addCharges" value={formData.addCharges} onChange={handleInputChange} name="addCharges" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cost-center-section">
        <div className="d-flex mt-3 cursor-pointer slide-header" onClick={() => setSupplierTab(!SupplierTab)}>
          <div className="h6 pt-1">Supplier Details</div>
        </div>
        <div className={`slide-content ${SupplierTab ? 'open' : 'closed'}`}>
          <div className="border-box2 p-3">
            <div className="form-group row">
              <div className="d-flex justify-content-between col">
                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">
                  Supplier
                </label>
                <Select
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  className="w-100 p-0"
                  value={formData.vendorName}
                  onChange={(selectedOption) => handleSupplierChange(selectedOption)}
                  options={supplier?.map((sup) => ({ value: sup, label: sup?.supplierName }))}
                />
              </div>
              <div className="d-flex justify-content-between col">
                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">
                  Supplier ID
                </label>
                <Select
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  className="w-100 p-0"
                  value={formData.vendorId}
                  onChange={(selectedOption) => handleSupplierChange(selectedOption)}
                  options={supplier?.map((sup) => ({ value: sup, label: sup?.supplier_ID }))}
                />
              </div>
              <div className="d-flex justify-content-between col">
                <label htmlFor="Currency" className="form-label  pt-2 start">
                  Currency{' '}
                </label>
                <Select
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  className="w-100 p-0"
                  isSearchable={true}
                  value={SelectedCurrency}
                  onChange={(e) => handlecurChange(e)}
                  options={currencyList?.map((po) => ({
                    value: po,
                    label: po.code,
                  }))}
                />
              </div>
              <div className="d-flex justify-content-between col">
                <label htmlFor="ExchangeRate" className="form-label  pt-2 start">
                  Exchange Rate{' '}
                </label>
                <input
                  type="number"
                  className="form-Input w-100"
                  disabled
                  onWheel={(e) => e.target.blur()}
                  id="exchangeRate"
                  value={SelectedCurrency?.value?.conversionRate}
                  onChange={handleInputChange}
                  name="exchangeRate"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cost-center-section">
        <div className="d-flex mt-3 cursor-pointer slide-header" onClick={() => setCostTab(!CostTab)}>
          <div className="h6 pt-1">Cost Center Details</div>
        </div>
        <div className={`slide-content ${CostTab ? 'open' : 'closed'}`}>
          <div className="border-box2 p-3">
            <div className="form-group row">
              <div className="d-flex justify-content-between col">
                <label htmlFor="PropertyGroup" className="form-label  pt-2 start">
                  Property
                </label>
                <Select
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  className="w-100 p-0"
                  value={formData.costCenter1}
                  onChange={handleCost1}
                  options={cost1?.map((sup) => ({ value: sup, label: sup?.description }))}
                />
              </div>
              <div className="d-flex justify-content-between col">
                <label htmlFor="Property" className="form-label  pt-2 start">
                  Unit
                </label>
                <Select
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  className="w-100 p-0"
                  value={formData.costCenter2}
                  onChange={handleCost2}
                  options={cost2?.map((sup) => ({ value: sup, label: sup?.text }))}
                />
              </div>
              <div className="d-flex justify-content-between col">
                <label htmlFor="Department" className="form-label  pt-2 start">
                  Cost Center 3
                </label>
                <Select
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  className="w-100 p-0"
                  value={formData.costCenter3}
                  onChange={handleCost3}
                  options={cost3?.map((sup) => ({ value: sup, label: sup?.description }))}
                />
              </div>
              <div className="d-flex justify-content-between col">
                <label htmlFor="Department" className="form-label  pt-2 start">
                  Cost Center 4
                </label>
                <Select
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  className="w-100 p-0"
                  value={formData.costCenter4}
                  onChange={handleCost4}
                  options={cost4?.map((sup) => ({ value: sup, label: sup?.description }))}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cost-center-section">
        <div className="d-flex mt-3 cursor-pointer slide-header" onClick={() => setOtherTab(!OtherTab)}>
          <div className="h6 pt-1">Other Details</div>
        </div>
        <div className={`slide-content ${OtherTab ? 'open' : 'closed'}`}>
          <div className="border-box2 p-3">
            <div className="d-flex justify-content-between ">
              <div className="d-flex justify-content-between col-md-4">
                <label htmlFor="subcatname" className="form-label  pt-2 start">
                  Remarks
                </label>
                <input name="remarks" type="text" className="form-Input w-100" id="subcatname" value={formData.remarks} onChange={handleInputChange} />
              </div>
              <div className="col-2 brderbox center p-2" onClick={() => handleOpen()}>
                {'Attachment'}
              </div>
              <div className="col-md-3 d-flex gap-2 justify-content-around">
                <div className="form-check">
                  <input
                    style={{ width: '26px', height: '26px' }}
                    type="checkbox"
                    className="form-check-input"
                    checked={isVatExcluded}
                    onChange={handleVatChange}
                  />
                  <label className="form-check-label mx-2 mt-1">Vat Excluded</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="slide-container p-2 mt-3">
        <div className="container-fluid">
          <div className="nav nav-pills overslid d-flex gap-4">
            {/* Nav tabs */}
            <div className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`} onClick={() => handleTabClick(0)}>
              Items
            </div>
            <div className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`} onClick={() => handleTabClick(1)}>
              Authorization
            </div>
            <div className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`} onClick={() => handleTabClick(2)}>
              Message
            </div>
          </div>
        </div>
      </div>
      <div className="grid-1 brderbox2 p-2 mb-3">
        {gridVisibility[0] && (
          <DirectPurchaseGrid
            onRequisitionData={handleRequisitionData}
            itemData={POData} itemtype={itemtype}
            selectedCheck={isVatExcluded}
            currencyPrecision={currencyPrecision?.exp1 || 3}
          />
        )}
        {gridVisibility[1] && <AuthorizationGrn handleAuthorization={handleAuthorization} usersDetails={usersDetails} setUser={setUser} itemData={POData} />}
        {gridVisibility[2] && (
          <div className="grid-3 border">
            <MessageGrid handleMessage={handleMessage} />
          </div>
        )}
        {gridVisibility[3] && <ItemGridGRN onRequisitionData={handleRequisitionData} />}
      </div>
      <div>
        <Attachment
          open={attachmentModal}
          onClose={closeModal}
          documentNo={formData.GRNNO}
          rows={attachments}
          readOnly={isReadOnly}
          onFileSelect={handleFileSelect}
          onRemarkChange={handleRemarkChange}
          onDelete={handleDelete}
          onView={handleView}
          onSave={handleUpload}
          previewImage={previewImage}
          previewOpen={previewModal}
          closePreview={() => setPreviewModal(false)}
        />
      </div>
      <Modal size="md" show={docModal} onHide={() => setDocModal(false)} backdrop="static" contentLabel="Doc Id Modal">
        <Modal.Header closeButton>
          <Modal.Title className="center">Invoice Number</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-danger">The Invoice number already exists. Click "Generate" to assign a new number.</p>
        </Modal.Body>
        <Modal.Footer className="end p-3">
          <button className="mainbtnGry" onClick={onCloseModal}>
            Cancel
          </button>
          <button className="mainbtnRed" onClick={GenerateNumber}>
            Generate
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CreateDirectPurchase;
